export default function voyageConstraintsDataToJson(constraints) {
    return {
        id: constraints.id,
        max_turning_angle: constraints.maxTurningAngle,
        max_wind_service_speed: constraints.maxWindServiceSpeed,
        max_wind_cruise_speed: constraints.maxWindCruiseSpeed,
        max_wave_service_height: constraints.maxWaveServiceHeight,
        max_wave_cruise_height: constraints.maxWaveCruiseHeight,
    };
}